import { ComposerPrimitive } from "@assistant-ui/react";
import { PaperAirplaneIcon } from "@heroicons/react/24/outline";
import React from "react";

interface ChatComposerProps {
  placeholder?: string;
  maxLength?: number;
  inputAriaLabel?: string;
  sendLabel?: string;
}

/**
 * Message input with a send button. Enter sends, Shift+Enter inserts a newline; the send
 * button disables itself while the input is empty or the assistant is responding.
 * Must be rendered inside an `AssistantRuntimeProvider`.
 */
const ChatComposer = ({
  placeholder = "Ask a question…",
  maxLength,
  inputAriaLabel = "Message input",
  sendLabel = "Send",
}: ChatComposerProps) => {
  return (
    <ComposerPrimitive.Root className="flex shrink-0 items-end gap-2 border-t border-neutral-200 p-3">
      <ComposerPrimitive.Input
        aria-label={inputAriaLabel}
        placeholder={placeholder}
        rows={1}
        maxLength={maxLength}
        className="block max-h-32 min-h-[40px] w-full resize-none rounded-md px-3 py-2 text-sm leading-5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-primary-600"
      />
      <ComposerPrimitive.Send className="flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-primary-600 text-white hover:bg-primary-700 disabled:cursor-not-allowed disabled:opacity-40">
        <span className="sr-only">{sendLabel}</span>
        <PaperAirplaneIcon className="h-4 w-4" aria-hidden="true" />
      </ComposerPrimitive.Send>
    </ComposerPrimitive.Root>
  );
};

export default ChatComposer;
